import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {CustomTiModule} from "./custom/custom.ti.module";

import { environment } from '../environments/environment';
import * as Sentry from "@sentry/angular";

Sentry.init({
    dsn: "https://a72b0d35bc9541f49d393619787e086f@sentry.twingle.de/6",
    integrations: [Sentry.captureConsoleIntegration({levels: ['error']})],
    ignoreErrors: [
        'Non-Error exception captured',
        'Non-Error promise rejection captured'
    ]
});

if (environment.production) {
    enableProdMode();
}
platformBrowserDynamic().bootstrapModule(CustomTiModule);
